import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
import { NaturezaVendaSituacaoModule } from '../situacao';

import { NaturezaVendaMultiselectComponent } from './natureza-venda-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule,
        NaturezaVendaSituacaoModule
    ],
    declarations: [
        NaturezaVendaMultiselectComponent
    ],
    exports: [
        NaturezaVendaMultiselectComponent
    ]
})
export class NaturezaVendaMultiselectModule { }
